function initPriorityMenus() {
  const navs = document.querySelectorAll('.header__inline-menu ul');
  if (!navs.length) return;

  navs.forEach((nav) => {
    if (nav.dataset.priorityInit === 'true') return;
    nav.dataset.priorityInit = 'true';

    // Create "More"
    let moreItem = document.createElement('li');
    moreItem.className = 'menu-more';
    moreItem.innerHTML = `
      <button type="button" aria-haspopup="true" aria-expanded="false" class="menu-more__button">
        More
        <svg class="caret" width="14" height="14" viewBox="0 0 10 10" aria-hidden="true" focusable="false">
          <path d="M1 3l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5"/>
        </svg>
      </button>
      <ul class="menu-more__dropdown" role="menu"></ul>
    `;

    const button = moreItem.querySelector('button');
    const dropdown = moreItem.querySelector('.menu-more__dropdown');

    nav.appendChild(moreItem);

    // 🔥 Dropdown positioning fix
    function adjustDropdownPosition() {
      moreItem.classList.remove('is-flip');

      const rect = dropdown.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      if (rect.right > viewportWidth) {
        moreItem.classList.add('is-flip');
      }

      if (rect.left < 0) {
        moreItem.classList.remove('is-flip');
      }
    }

    function updateMenu() {
      const width = window.innerWidth;

      // reset outside range
      if (width > 1480 || width < 1025) {
        while (dropdown.children.length > 0) {
          nav.insertBefore(dropdown.children[0], moreItem);
        }

        moreItem.style.display = 'none';
        moreItem.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');

        nav.style.visibility = '';
        return;
      }

      requestAnimationFrame(() => {
        nav.style.visibility = 'hidden';

        if (!nav.contains(moreItem)) {
          nav.appendChild(moreItem);
        }

        // reset items
        while (dropdown.children.length > 0) {
          nav.insertBefore(dropdown.children[0], moreItem);
        }

        const BUFFER = 0;
        const navWidth = Math.floor(nav.getBoundingClientRect().width);

        const items = Array.from(nav.children).filter(el => el !== moreItem);

        // remove "More" from layout temporarily
        moreItem.style.position = 'absolute';
        moreItem.style.visibility = 'hidden';

        let usedWidth = 0;
        let cutoff = items.length;

        // STEP 1: measure without "More"
        for (let i = 0; i < items.length; i++) {
          usedWidth += Math.ceil(items[i].getBoundingClientRect().width);

          if (usedWidth + BUFFER > navWidth) {
            cutoff = i;
            break;
          }
        }

        // if everything fits
        if (cutoff === items.length) {
          moreItem.style.display = 'none';
          moreItem.style.position = '';
          moreItem.style.visibility = '';

          nav.style.visibility = '';
          return;
        }

        // restore "More"
        moreItem.style.display = 'inline-block';
        moreItem.style.position = '';
        moreItem.style.visibility = '';

        const moreWidth = moreItem.getBoundingClientRect().width;

        // STEP 2: adjust cutoff for "More"
        while (cutoff > 0 && usedWidth + moreWidth + BUFFER > navWidth) {
          cutoff--;
          usedWidth -= items[cutoff].getBoundingClientRect().width;
        }

        // STEP 3: move overflow items
        for (let i = items.length - 1; i >= cutoff; i--) {
          dropdown.insertBefore(items[i], dropdown.firstChild);
        }

        nav.style.visibility = '';
      });
    }

    // Toggle
    button.addEventListener('click', () => {
      const isOpen = moreItem.classList.toggle('is-open');
      button.setAttribute('aria-expanded', isOpen);

      if (isOpen) {
        requestAnimationFrame(() => {
          adjustDropdownPosition();
        });
      }
    });

    // Keyboard support
    button.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        button.click();
      }

      if (e.key === 'Escape') {
        moreItem.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        button.focus();
      }
    });

    // Click outside
    document.addEventListener('click', (e) => {
      if (!moreItem.contains(e.target)) {
        moreItem.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      }
    });

    // Resize handling
    let resizeTimeout;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateMenu();

        if (moreItem.classList.contains('is-open')) {
          adjustDropdownPosition();
        }
      }, 100);
    });

    updateMenu();
  });
}

document.addEventListener('DOMContentLoaded', initPriorityMenus);